export default class Header {
  get CLASSES() {
    return {
      isFixed: 'is-fixed',
      isShow: 'is-show',
      isHide: 'is-hide',
    };
  }

  constructor() {
    this.$header = document.querySelector('[data-header]');
    if (!this.$header) return;
    this.options = {
      showDelay: 200,
      startPosition: 0,
      lastPosition: 0,
      upFlg: false,
      setTimeoutFlg: false,
      setTimeoutId: 0,
    };
    this.init();
  }

  init() {
    this.setFixedOnScroll();
    this.onResize();
  }

  setFixedOnScroll() {
    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;

      if (scrollTop > this.options.lastPosition) {
        this.options.upFlg = false;
        clearTimeout(this.options.setTimeoutId);
        this.options.setTimeoutFlg = false;

        if (scrollTop > this.$header.clientHeight) {
          this.$header.classList.add(this.CLASSES.isFixed);
        }

        const pageHeight = document.documentElement.scrollHeight;
        const scrollBottom = window.innerHeight + scrollTop;

        if (pageHeight <= scrollBottom) {
          this.show();
        } else {
          if (this.$header.classList.contains(this.CLASSES.isShow)) {
            this.hide();
          }
        }
      } else if (scrollTop < this.options.lastPosition) {
        this.options.upFlg = true;

        if (scrollTop <= 0) {
          this.$header.classList.remove(this.CLASSES.isFixed, this.CLASSES.isShow, this.CLASSES.isHide);
        } else {
          if (!this.options.setTimeoutFlg) {
            this.options.setTimeoutFlg = true;
            this.options.setTimeoutId = setTimeout(() => {
              if (this.options.upFlg && this.$header.classList.contains(this.CLASSES.isFixed)) {
                this.show();
              }
            }, this.options.showDelay);
          }
        }
      }

      this.options.lastPosition = scrollTop;
    });
  }

  show() {
    this.$header.classList.remove(this.CLASSES.isHide);
    this.$header.classList.add(this.CLASSES.isShow);
  }

  hide() {
    this.$header.classList.remove(this.CLASSES.isShow);
    this.$header.classList.add(this.CLASSES.isHide);
  }

  onResize() {
    window.addEventListener('resize', () => this.setFixedOnScroll());
  }
}